<!-- <script setup>
import { inject } from 'vue'

const areaExpanded_2 = inject('expandAll')
</script> -->


<template>

    <div class="element top-element yellow"
        v-bind:class="{ 'collapsed': !areaExpanded, 'expanded': areaExpanded, 'repo-dev': repo === 'dev' }">
        <div class="element-heading">
            <div class="collapse-icon" @click="toggleCollapse">
                <i class="fa fa-plus" v-show="!areaExpanded"></i>
                <i class="fa fa-minus" v-show="areaExpanded"></i>
            </div>
            <div class="element-name">

                <div class="display-name">{{ area.display_name }}</div>
                <div class="output-identification-name">{{ area.output_identification_name }}</div>

                <b-badge pill variant="danger" v-if="area.has_game_not_on_list" v-b-tooltip.hover
                    title="Ten obszar zawiera co najmniej jedną grę z brakiem plików źródłowych">
                    Brak źródeł
                </b-badge>

                <b-badge pill variant="warning" v-if="area.has_not_approved_element" v-b-tooltip.hover
                    title="Ten obszar zawiera co najmniej jedną grę lub pakiet wymagający zatwierdzenia">
                    Elementy do zatwierdzenia
                </b-badge>

                <b-badge pill variant="warning" v-if="area.config_was_updated_since_last_approve" v-b-tooltip.hover
                    title="Konfiguracja została zaktualizowana od ostatniego zatwierdzenia">
                    Konfiguracja edytowana
                </b-badge>

                <b-badge pill variant="warning" v-if="area.translations_were_updated_since_last_approve"
                    v-b-tooltip.hover title="Tłumaczenia zostały zaktualizowana od ostatniego zatwierdzenia">
                    Tłumaczenia edytowane
                </b-badge>

            </div>
            <div class="element-buttons">

                <div class="buttons-row" v-show="!orderManagementState">

                    <b-button size="xs" variant="success" v-if="area.need_approve" @click="approveArea()">
                        Zatwierdź
                    </b-button>

                    <b-button size="xs" variant="primary" v-if="repo === 'dev'" @click="editArea">
                        Edytuj
                    </b-button>

                    <b-button size="xs" variant="danger" @click="deleteArea">
                        Usuń
                    </b-button>

                </div>

                <div class="buttons-row" v-show="orderManagementState">

                    <a href="javascript:void(0);" class="text-primary up" v-show="repo === 'dev'" @click="moveUp"
                        title="W górę"><i class="fa fa-chevron-up"></i></a>
                    <span>&nbsp;</span>
                    <a href="javascript:void(0);" class="text-primary down" v-show="repo === 'dev'" @click="moveDown"
                        title="W dół"><i class="fa fa-chevron-down"></i></a>

                </div>

            </div>
        </div>
        <slot :area-expanded="areaExpanded" :area-created="areaCreated"></slot>
        <div class="element nested-element green" v-bind:class="{ 'repo-dev': repo === 'dev' }" v-if="repo === 'dev'"
            v-show="areaExpanded">
            <div class="element-heading">
                <div class="element-text" v-bind:class="{ 'disabled': (repo !== 'dev' || orderManagementState) }">
                    <a href="javascript:void(0);" class="text-primary" @click="addPackage">Dodaj pakiet</a>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {

    name: 'GameLibraryArea',

    props: [
        'repo',
        'area',
        'library',
        'orderManagementState',
        'expandAll',
    ],

    data() {
        return {
            eventHub: window.eventHub,
            areaExpanded: false,
            state: false
        }
    },
    computed: {
        areaCreated: function () {
            if (this.expandAll){ // spróbować warunku if (this.expandAll)
                this.areaExpanded = true
                this.state = true
            }
            if (!this.state && this.areaExpanded){
                this.state = true
            }
            return this.state                    
        }
    },


    mounted() {

        this.eventHub.$on('game-library-collapse-all', () => {
            this.areaExpanded = false;
        });

        this.eventHub.$on('game-library-expand-all', () => {
            this.areaExpanded = true;
        });

    },

    methods: {

        toggleCollapse() {
            this.areaExpanded = !this.areaExpanded
            if (!this.state){
                this.state = true
            }
        },

        editArea() {
            this.eventHub.$emit('game-library-edit-area', this.area);
        },

        deleteArea() {
            this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć obszar: ' + this.area.display_name + '?' + (this.repo === 'prod' ? 'Jeśli obszar zawiera materiały marketingowe, zostaną one również usunięte.' : ''), {
                title: 'Usuń obszar',
                size: 'sm',
                okVariant: 'danger',
                okTitle: 'Usuń',
                cancelTitle: 'Anuluj',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.eventHub.$emit('processing-start');
                        axios.delete(route('game::game-library.delete-area', { repo: this.repo, id: this.area.id }))
                            .then(response => {
                                this.eventHub.$emit('game-library-updated', response.data.data.library);
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', response.data.message, 'success');
                            })
                            .catch(error => {
                                console.log(error);
                                this.eventHub.$emit('processing-finish');
                                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                            });
                    }
                });
        },

        approveArea() {
            this.eventHub.$emit('game-library-approve-element', 'area', {
                id: this.area.id,
                display_name: this.area.display_name,
                updated_at: this.area.updated_at ? (new Date(this.area.updated_at)).toLocaleString() : '---',
                approved_at: this.area.approved_at ? (new Date(this.area.approved_at)).toLocaleString() : '---',
                files_updated_at: this.area.files_updated_at ? (new Date(this.area.files_updated_at)).toLocaleString() : '---',
                translations_updated_at: this.area.translations_updated_at !== null ? (new Date(this.area.translations_updated_at)).toLocaleString() : '---',
                files_were_updated_since_last_approve: this.area.files_were_updated_since_last_approve,
                config_was_updated_since_last_approve: this.area.config_was_updated_since_last_approve,
                translations_were_updated_since_last_approve: this.area.translations_were_updated_since_last_approve,
            });
        },

        moveUp() {
            // Get index of element
            let areaIndex = this.library.findIndex(area => {
                return area.id === this.area.id;
            });

            let previousArea = this.library[areaIndex - 1];

            // Check if there is element before
            if (previousArea !== undefined) {

                let previousAreaNumberInOrder = previousArea.number_in_order;
                let currentAreaNumberInOrder = this.area.number_in_order;

                // Replace order number
                this.area.number_in_order = previousAreaNumberInOrder;
                previousArea.number_in_order = currentAreaNumberInOrder;

                // Update library variable
                this.library[areaIndex] = previousArea;
                this.library[areaIndex - 1] = this.area;
                this.eventHub.$emit('game-library-updated', this.library);
            }
        },

        moveDown() {
            // Get index of element
            let index = this.library.findIndex(area => {
                return area.id === this.area.id;
            });

            let nextArea = this.library[index + 1];

            // Check if there is element after
            if (nextArea !== undefined) {

                let nextAreaNumberInOrder = nextArea.number_in_order;
                let currentAreaNumberInOrder = this.area.number_in_order;

                // Replace order number
                this.area.number_in_order = nextAreaNumberInOrder;
                nextArea.number_in_order = currentAreaNumberInOrder;

                // Update library variable
                this.library[index] = nextArea;
                this.library[index + 1] = this.area;
                this.eventHub.$emit('game-library-updated', this.library);
            }
        },

        addPackage() {
            this.eventHub.$emit('game-library-add-package', this.area.id);
        },

    }

}
</script>

<style scoped></style>
